import {UserService} from '../../../../shared/services/user.service';
import {Customer} from '../../../../shared/models/customer';
import {ImageService} from '../../../../shared/services/image.service';
import {ArticleService} from '../../../../shared/services/article.service';
import {Article} from '../../../../shared/models/article';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {CartService} from '../../../../shared/services/cart.service';
// TODO: reactivar mayorista/minorista — descomentar este import
// import { CustomerService } from 'src/app/shared/services/customer.service';

declare var swal: any;

@Component({
    selector: 'app-product-left-sidebar',
    templateUrl: './product-left-sidebar.component.html',
    styleUrls: ['./product-left-sidebar.component.scss'],
    standalone: false
})
export class ProductLeftSidebarComponent implements OnInit {

  constructor(
    
    private _articleService: ArticleService,
    private _route: ActivatedRoute,
    private cartService: CartService,
    private uploadService: ImageService,
    private userService: UserService,
    // TODO: reactivar mayorista/minorista — descomentar customerService
    // private customerService: CustomerService
    ) {
  }

  public counter = 1;
  public selectedSize: any = '';
  public product: Article;
  public dolar: number;

  public slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
  };

  public slideNavConfig = {
    vertical: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-slick',
    arrows: false,
    dots: false,
    focusOnSelect: true
  };

  public isAvailableResult = false;

  ngOnInit() {
    this.getArticle();
  }

  public addToCart(product: Article, quantity: number) {
    if (quantity <= 0) return;
    this.cartService.addToCart(product, quantity);
  }

  getArticle() {
    this._route.params.forEach((params: Params) => {
      const id = params['id'];
      this._articleService.getArticle(id, null).subscribe(
        response => {
          this.product = {...response};
          this.isAvailable(this.product);
        },
        error => {
          if (error.status === 0) {
            swal({
              title: 'Error',
              text: 'Error en la llamada al servidor',
              icon: 'error',
              button: 'cerrar',
            });
          }
        }
      );
    }).then();
  }


  getPhotosArray(photos: string) {
    return this.uploadService.parsePhotoArray(photos);
  }

  geturl(image: string) {
    return this.uploadService.makeUrl(image);
  }

  getPrice(p: Article) {
    const customer: Customer = this.userService.getIdentity();
    if (customer) {
      return this._articleService.getPrice(p, customer.listPrice);
    } else {
      return p.unitPrice;
    }
  }

  validatePrice(p: Article) {
    return this.getPrice(p) > 0;
  }

  isAvailable(_p: Article): void {
    // TODO: reactivar mayorista/minorista — restaurar lógica original:
    // const customerId = this.userService.getIdentity()?.id || null;
    // if (!customerId) {
    //   this.isAvailableResult = p.unitInStock > 0;
    //   return;
    // }
    // this.customerService.isWholesaler(customerId).subscribe((res: boolean) => {
    //   this.isAvailableResult = res || (!res && p.unitInStock > 0);
    // });
    this.isAvailableResult = true;
  }

}
